import { ReferralSource, ResourceHoldData } from '../../../api';

export enum EditOrderPanels {
  DateAndTimePanel = 'date_and_time',
  ExperienceDetailPanel = 'experience_detail',
  PersonalDetailsPanel = 'personal_details',
  ManagementPanel = 'management',
  SeatingPanel = 'seating',
  CommunicationTrackingPanel = 'communication_tracking',
  PaymentLinksPanel = 'payment_links',
  BulkSessionsPanel = 'bulk_sessions',
  VoucherRedemptionsPanel = 'voucher_redemptions',
  AllOpen = 'all_open',
}

export type PersonalDetails = {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  custom_personal_details?: Record<string, number | string | boolean>;
  referral_source?: string;
  voucher_greeting_message?: string;
  recipient_email?: string;
  delivery_date?: string | null;
  delivery_time?: string | null;
  should_send_delayed?: boolean;
  alternative_full_name?: string;
};

export type EditOrderFormValues = {
  firstname: string;
  lastname: string;
  alternative_full_name: string;
  email: string;
  phone: string;
  custom_personal_details: Record<string, any>;
  referral_source?: ReferralSource;
  voucher_greeting_message: string;
  should_send_to_recipient: boolean;
  recipient_email: string;
  delivery_date: string | null;
  delivery_time: string;
  should_send_delayed: boolean;

  date: string;
  timeSeconds: number;
  privateOrderEndTimeSeconds: number;

  selectedUsersIds: string[];
  selectedHolds: ResourceHoldData[];
  skipResourceAssignment: boolean;
  resourceOptionId: string;
  comment: string;
  shouldUnarchive: boolean;
  expirationDate: string;
  skipCustomerEditNotifications: boolean;

  createPaymentLink: boolean;
  paymentLinkHoldDate: string;
  paymentLinkHoldTime: string;
  paymentLinkHoldQuickKey: string;
  // The amount a payment link charges up front; follows its default until staff edit it (upfrontEdited).
  upfrontAmount: number;
  upfrontEdited: boolean;
};
